import {
 baseAPI,
 baseTransformResponse,
 baseTransformResponse2,
} from 'api/baseApi'
import { ApiResponce } from 'types'
import {
 TAddTwilioInput,
 TIntegrationFBPages,
 TIntegrationItem,
 TwilioData,
} from '../types'

export const settingApi = baseAPI.injectEndpoints({
 endpoints: ({ query, mutation }) => ({
  integration: query<TIntegrationItem[], void>({
   query: (body) => ({
    url: 'user/integration',
    method: 'get',
    body,
   }),
   providesTags: ['FB-INT_LIST'],
   transformResponse: (res: ApiResponce) => res.data,
  }),
  getTwilioList: query<TwilioData, void>({
   query: (body) => ({
    url: 'user/twilio-integration',
    method: 'get',
    body,
   }),
   providesTags: ['TWL-INT_DTLS'],
   transformResponse: (res: ApiResponce) => res.data,
  }),
  fbPages: mutation<void, TIntegrationFBPages>({
   query: (body) => ({
    url: 'user/facebook/pages',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse2,
  }),
  twilioIntegrationStore: mutation<void, TAddTwilioInput>({
   query: (body) => ({
    url: 'user/twilio-integration-store',
    method: 'post',
    body,
   }),
   invalidatesTags: ['GET_MY_PROFILE', 'GLOBAL_SETTINGS'],
   transformResponse: baseTransformResponse2,
  }),
  unlinkFbPage: mutation<void, { page_id?: string; type?: 'multiple' }>({
   query: (body) => ({
    url: 'user/facebook-page-unlink',
    method: 'post',
    body,
   }),
   transformResponse: baseTransformResponse,
  }),
  unlinkTwilioe: mutation<void, void>({
   query: (body) => ({
    url: 'user/twilio-unlink',
    method: 'post',
    body,
   }),
   invalidatesTags: ['GET_MY_PROFILE', 'GLOBAL_SETTINGS'],
   transformResponse: baseTransformResponse,
  }),
 }),
})

export const {
 useUnlinkTwilioeMutation,
 useTwilioIntegrationStoreMutation,
 useGetTwilioListQuery,
 useIntegrationQuery,
 useFbPagesMutation,
 useUnlinkFbPageMutation,
} = settingApi
